export default __webpack_public_path__ + "static/media/iconCamera.7ebb7a42.svg";